const getToken = state => state.token;
const getIsLogged = state => state.isLogged;

export default {
  getToken,
  getIsLogged,
};
